let lastUrl: string | null = null;

type HistoryMethod = 'replace' | 'push';

interface HistoryOptions {
  url?: string;
  pathname?: string;
  search?: string;
  state?: any;
  title?: string;
  force?: boolean;
}

const buildUrl = (pathname?: string, search?: string) => {
  const path = pathname ?? window.location.pathname;
  const query = search ?? window.location.search;

  if (query) {
    return query.startsWith('?') ? `${path}${query}` : `${path}?${query}`;
  }
  return path;
};

const safeHistoryAction = (method: HistoryMethod, options?: HistoryOptions) => {
  if (typeof window === 'undefined' || !window.history) {
    return;
  }

  const nextUrl = options?.url ?? buildUrl(options?.pathname, options?.search);

  if (!options?.force && lastUrl === nextUrl) {
    return;
  }

  try {
    if (method === 'replace') {
      window.history.replaceState(
        options?.state ?? null,
        options?.title ?? '',
        nextUrl,
      );
    } else {
      window.history.pushState(
        options?.state ?? null,
        options?.title ?? '',
        nextUrl,
      );
    }
    lastUrl = nextUrl;
  } catch (error) {
    console.warn(`Failed to ${method} history state`, error);
  }
};

export const safeReplaceState = (options?: HistoryOptions) =>
  safeHistoryAction('replace', options);

export const safePushState = (options?: HistoryOptions) =>
  safeHistoryAction('push', options);
